import React from 'react';
import { propTypes, defaultProps } from './propsValidation';
import * as S from '../styles';
import Header from '~/components/Header';
import LockView from '~/components/LockView';

const PrivateLayout = ({ children, navBar, subHeader, location, footer }) => {
  return (
    <S.Wrapper>
      {location.pathname.includes('dashboard') && <S.BGbit />}
      <S.HeaderContainer>
        <Header />
        <S.SubHeaderContainer id="subheader-root">
          {subHeader}
        </S.SubHeaderContainer>
      </S.HeaderContainer>
      <S.Container
        mobileBackground={
          location.pathname.includes('global-statistics') ? 'transparent' : null
        }
      >
        <S.Content>{children}</S.Content>
        {navBar && navBar}
        <div id="modal-left-root" />
        <div id="modal-right-root" />
      </S.Container>
      <S.Footer>{footer}</S.Footer>
      <div id="modal-root" />
      <LockView />
    </S.Wrapper>
  );
};

PrivateLayout.propTypes = propTypes;

PrivateLayout.defaultProps = defaultProps;

export default PrivateLayout;
